const publicEmail = (value, name) => {
    if (!value || !/^[^\s<>@,]+@[^\s<>@,]+\.[^\s<>@,]+$/.test(value)) {
        throw new Error(`Missing or invalid public contact configuration: ${name}`);
    }
    return value;
};

export const PUBLIC_CONTACTS = {
    sales: publicEmail(process.env.REACT_APP_SALES_EMAIL, 'REACT_APP_SALES_EMAIL'),
    amanda: publicEmail(process.env.REACT_APP_AMANDA_EMAIL, 'REACT_APP_AMANDA_EMAIL'),
};